import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { I18N_NAMESPACES, WINE_LIST_NAME_MAX_LENGTH } from "../../../helpers/constants";
import { UPDATE_OR_CREATE_WINE_LIST } from "../../../graphql/mutations";
import { GET_ALL_WINE_LISTS_CONTROLLED_BY_MEMBER } from "../../../graphql/queries";
import { Input } from "../Input";
import StyledButtonMutation from "../StyledButtonMutation";
import { CharacterCount, StyledInputHolder } from "./style";

interface WineListCreationProps {
  memberId: number;
  onListCreated: Function;
}

const WineListCreation = ({ memberId, onListCreated }: WineListCreationProps) => {
  const [listName, setListName] = useState<string>("");
  const { t } = useTranslation(I18N_NAMESPACES.MY_CELLAR);
  const placeholder = t("myCellar:createListPlaceholder") || "";
  const buttonLabel = t("myCellar:createListButton") || "";

  const characterCount = t("myCellar:createListCharacterCount", {
    usedCharacters: listName.length,
    maxCharacters: WINE_LIST_NAME_MAX_LENGTH,
  });

  const onUpdateName = (value: string) => {
    if (value.length <= WINE_LIST_NAME_MAX_LENGTH) {
      setListName(value);
    }
  };

  return (
    <>
      <StyledInputHolder>
        <Input
          maxLength={WINE_LIST_NAME_MAX_LENGTH}
          placeholder={placeholder}
          onChange={(e) => onUpdateName(e.target.value)}
        />
      </StyledInputHolder>

      <CharacterCount>{characterCount}</CharacterCount>

      <StyledButtonMutation
        input={{ memberId, name: listName, isPublic: true }}
        mutationProp={UPDATE_OR_CREATE_WINE_LIST}
        reFetchQueriesProp={[
          {
            query: GET_ALL_WINE_LISTS_CONTROLLED_BY_MEMBER,
            variables: { memberId },
          },
        ]}
        awaitRefetchQueries
        label={buttonLabel}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        handleResponse={(data: any) => onListCreated(data)}
        full
        lg
      />
    </>
  );
};

export default WineListCreation;
